module.exports = __webpack_public_path__ + "img/22-ABITO-NOVELLO-SML-COLORI-GARZA-RICAMO-SMERALDO8copia.4d09adfa.jpg";